module.exports = __webpack_public_path__ + "static/media/bank-bank-transparency-layer.9fd6b1b9.png";